import React from 'react';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { offerColumn } from './columns';
import { toast } from 'react-toastify';
import { Box, Button, Modal } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { getAllOffersAsync } from './OfferStore/offerStoreSlice';
import AddOfferForm from './AddOfferForm';
import UpdateOfferForm from './UpdateOfferForm';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
import { getAllBuzzUsers } from '../../Dashboard/BuzzSlice';

const DOMAIN_OPTION = [
  { label: 'SITE', value: 'SITE' },
  { label: 'USER', value: 'USER' },
  { label: 'COURSE', value: 'PRODUCT' },
];

const Offer = () => {
  const [open, setOpen] = React.useState(false);
  const [updateOfferOpen, setUpdateOfferOpen] = React.useState(false);
  const [domain, setDomain] = React.useState('SITE');
  const [page, setPage] = React.useState(1);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleUpdateOfferClose = () => setUpdateOfferOpen(false);

  const dispatch = useDispatch();
  const { offers, offersCount } = useSelector((state) => {
    const { offerReducer } = state;

    return {
      offers: offerReducer.offers && offerReducer.offers.fetchedOffers,
      offersCount: offerReducer.offers && offerReducer.offers.count,
    };
  });

  React.useEffect(() => {
    fetchData();
  }, [domain]);

  const fetchData = async () => {
    try {
      dispatch(getAllBuzzUsers({ userType: 'BUZZ_ONE' }));
      dispatch(
        getAllOffersAsync({
          params: {
            offerDomain: domain,
          },
        })
      )
        .unwrap()
        .then(() => {
          // toast.success('All offers were fetched successfully!');
        });
    } catch (error) {
      toast.error('Offers could not be fetched. Please try again!');
    }
  };

  const handleDomain = (e) => {
    setDomain(e.target.value);

    // if (e.target.value !== '') {
    //   dispatch(
    //     getAllOffersAsync({
    //       params: {
    //         offerDomain: e.target.value,
    //       },
    //     })
    //   );
    // }
  };

  const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getAllOffersAsync({
          params: { page: val, limit: 10, offerDomain: domain },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All offers were fetched successfully!');
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };

  return (
    <Box>
      <Button onClick={handleOpen} variant="contained" color="primary">
        Add Offer
      </Button>
      <Box my={4}>
        <Box mb={2}>
          <BuzzSelect
            width={180}
            name="status"
            size={'small'}
            placeholder={'Select Type'}
            value={domain}
            onChange={handleDomain}
            label="Select Type"
            valueKey="value"
            labelKey="label"
            options={DOMAIN_OPTION}
          />
        </Box>
        <BuzzTable columns={offerColumn} data={offers} />
        <Box display="flex" justifyContent="center">
          <BuzzPagination
            onClick={handlePageChange}
            total={offersCount}
            pageNo={page}
            defaultPage={1}
            perPage={10}
          />
        </Box>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <AddOfferForm fetchDefaultData={fetchData} handleClose={handleClose} />
      </Modal>

      <Modal
        open={updateOfferOpen}
        onClose={handleUpdateOfferClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <UpdateOfferForm
          fetchDefaultData={fetchData}
          defaultData={updateOfferOpen}
          handleClose={handleUpdateOfferClose}
        />
      </Modal>
    </Box>
  );
};

export default Offer;
